module.exports = __webpack_public_path__ + "assets/app/img/icon-warning-small.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/images/icon-warning-small.png
// module id = jGIB
// module chunks = 1